import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { DailyDateRangeSelectorComponent } from '../daily-date-range-selector/daily-date-range-selector.component';
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl, FormControl, ValidationErrors, ControlContainer, NgForm } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BhpPeriodMethodSelectorComponent } from '../bhp-period-method-selector/bhp-period-method-selector.component'
import { BhpSelectorData } from '../_models/bhp-selector';

@Component({
  selector: 'app-bhp-dialog',
  templateUrl: './bhp-dialog.component.html',
  styleUrls: ['./bhp-dialog.component.css']
})
export class BhpDialogComponent implements OnInit {


  bhpSelectorData: BhpSelectorData = {};
  constructor(public dialogRef: MatDialogRef<BhpDialogComponent>) { }

  ngOnInit(): void {
  }

  btnClicked(name) {
    if (name == 'Cancel') {
      this.dialogRef.close(null);
    }
    if (name == 'Create') {
      let result = {
        method: this.bhpSelectorData.methodId,
        beginDate: this.bhpSelectorData.beginDate,
        endDate: this.bhpSelectorData.endDate,
        useLastInjData: this.bhpSelectorData.useLastInjData
      }
      this.dialogRef.close(result);
    }
  }

}
